export const API_URL = process.env.REACT_APP_BASE_URL;
export default process.env.REACT_APP_INSTANCE_NAME;